var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2405 12.3121L7.27379 6.1194C7.19475 6.04927 7.13891 5.95675 7.11369 5.85413C7.08846 5.75151 7.09505 5.64365 7.13258 5.54487C7.1701 5.44608 7.23679 5.36105 7.32378 5.30106C7.41077 5.24106 7.51395 5.20895 7.61962 5.20898H23.63C23.7357 5.20895 23.8389 5.24106 23.9259 5.30106C24.0129 5.36105 24.0796 5.44608 24.1171 5.54487C24.1546 5.64365 24.1612 5.75151 24.136 5.85413C24.1108 5.95675 24.0549 6.04927 23.9759 6.1194L17.0092 12.3121C16.2196 13.0142 15.03 13.0142 14.2415 12.3121H14.2405Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.7917 4.42773H5.20833C4.44877 4.42829 3.72047 4.73027 3.18338 5.26736C2.64628 5.80445 2.3443 6.53275 2.34375 7.29232V17.709C2.3443 18.4686 2.64628 19.1968 3.18338 19.7339C3.72047 20.271 4.44877 20.573 5.20833 20.5736H19.7917C20.5512 20.573 21.2795 20.271 21.8166 19.7339C22.3537 19.1968 22.6557 18.4686 22.6562 17.709V7.29232C22.6557 6.53275 22.3537 5.80445 21.8166 5.26736C21.2795 4.73027 20.5512 4.42829 19.7917 4.42773ZM19.7917 5.99023C19.8333 5.99023 19.8687 6.01003 19.9094 6.01419L13.824 11.2298C13.0875 11.8611 11.9135 11.8611 11.1771 11.2298L5.09167 6.01419C5.13229 6.01003 5.16771 5.99023 5.20937 5.99023H19.7917ZM21.0938 17.709C21.0938 18.4267 20.5094 19.0111 19.7917 19.0111H5.20833C4.49062 19.0111 3.90625 18.4267 3.90625 17.709V7.29232C3.90625 7.22148 3.93542 7.15898 3.94687 7.09128L10.1594 12.4152C10.8114 12.9737 11.6415 13.2807 12.5 13.2807C13.3585 13.2807 14.1886 12.9737 14.8406 12.4152L21.0531 7.09128C21.0646 7.15898 21.0938 7.22148 21.0938 7.29232V17.709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email1.12b31dac6c356e44fed646a977aaffba.svg";
export { ForwardRef as ReactComponent };